import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import useAuthUserWithToken from '@Hooks/useAuthUserWithToken';
import { useLayoutEffect, useMemo } from 'react';

import { useAppSelector } from '@Hooks/index';
import { currentToken } from '@Store/selectors/authSelector';
import { useNavigate } from 'react-router-dom';
import BaseRoutePath from '@Router/baseRoutePathes.enum';

const ProtectedPage: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const authToken = useAppSelector(currentToken);
  const isAuthenticated = useIsAuthenticated();
  const { assignUserWithToken } = useAuthUserWithToken();
  const navigate = useNavigate();
  const { inProgress } = useMsal();

  useLayoutEffect(() => {
    if (
      !sessionStorage.getItem('redirectURL') &&
      !isAuthenticated &&
      window.location.pathname !== '/'
    ) {
      sessionStorage.setItem('redirectURL', `${window.location.pathname}`);
    }
  }, []);

  useLayoutEffect(() => {
    if (isAuthenticated) {
      assignUserWithToken();
    }
  }, [isAuthenticated]);

  const redirectToLogin = useMemo(() => {
    if (inProgress !== 'none' || !isAuthenticated) {
      return true;
    }
    return false;
  }, [authToken, inProgress]);

  if (redirectToLogin) {
    navigate(BaseRoutePath.LOGIN);
  }

  return authToken && isAuthenticated ? children : null;
};

export default ProtectedPage;
